import React, { useRef, useState, useEffect } from "react";

import { util } from "./util";
import { filterVariants } from "./filterVariants";
import { CaretIcon } from "./icons";

// Variants
const Variants = (props) => {
  const initialRender = useRef(true);
  const isGiftCard = props.productObject.type
    .toLowerCase()
    .includes("gift card");
  const bundleProduct = props.productObject.tags.filter((tag) =>
    tag.includes("bundle")
  );
  const isBundle = bundleProduct.length > 0;
  const isDigitalGiftCard = props.productObject.type === "Digital Gift Card";
  const isGiftWrap = props.productObject.type === "Gift Wrap";
  const params = new URLSearchParams(window.location.search);

  const filterCurrentVariants = () => {
    // if (props.productObject.variants.length > 1) {}
    let visibleVariants = props.productObject.variants;
    if (!isGiftCard) {
      visibleVariants = filterVariants(
        props.productObject,
        embroideryOption[0]?.position,
        false,
        sizeOption[0]?.position,
        hasSizeOption?activeSize:null
      );
      const fullHiddenVariants = props.productObject.variants.filter(
        (variant) =>
          variant.title.includes("/ Embroidery") ||
          variant.title.includes("/ Custom Embroidery")
      );

      setHiddenVariants(fullHiddenVariants);
    }
    
    setVisibleVariants(visibleVariants);
  };

  const activateVariant = (variant) => {
    // set active variant
    setActiveVariant(variant);
    // set ProductMeta.js current variant
    props.setMetaCurrentVariant(variant);

    // get extra data from liquid object - for inventory and availability
    const extraData = props.productData?.filter(
      (currentVariant) => currentVariant.id === variant.id
    );
    setExtraVariantData(extraData[0]);
    const productPageBadge = document.querySelector(".product__meta__badge");

    if (!isGiftCard && extraData.length > 0) {
      if (extraData[0].metafields.badge_callout) {
        productPageBadge.innerHTML = extraData[0].metafields.badge_callout;
        productPageBadge.classList.remove("visually-hidden");
      } else {
        productPageBadge.innerHTML = "";
        productPageBadge.classList.add("visually-hidden");
      }
    }
  };

  const keyPressVariant = (event, variant) => {
    if (event.charCode == 13) {
      activateVariant(variant);
    }
  };

  const keyPressSize = (event, size) => {
    if (event.charCode == 13) {
      setSize(size);
    }
  };

  const setUrl = () => {
    if (!params.has("embvariant") && activeVariant !== null) {
      const newHandle = props.productObject?.handle;
      const newPathname = `/products/${newHandle}`;
      
      // Preserve existing query parameters
      params.set("variant", activeVariant.id); // Ensure 'variant' is updated or preserved
      const newUrl = `${newPathname}?${params}`;
  
      // Update the URL without reloading the page
      window.history.replaceState({}, "", newUrl);

      if (!isGiftCard) {
        if (hiddenVariants.some((item) => item.id === activeVariant.id)) {
          props.openEmbModal();
          setTimeout(() => {
            activateVariant(props.productObject.variants[0]);
          }, 1000);
        }
      }
    }
  };

  const toggleDropdown = (value) => {
    setShowDropdown(value);
  };

  const setSize = (value) => {
    setActiveSize(value);
    setShowDropdown(false);
  };

  // use size option for gift card
  let sizeOption = props.productOptionVals;
  let hasSizeOption = true;

  // otherwise check if size option exists
  if (!isGiftCard) {
    sizeOption = props.productOptionVals.filter(
      (option) =>
        (option.name.toLowerCase().includes("size") &&
          !option.name.toLowerCase().includes("rug size") &&
          !option.name.toLowerCase().includes("robe size")) ||
        option.name.toLowerCase().includes("towel type") ||
        option.name.toLowerCase().includes("robe style")
    );
    hasSizeOption = sizeOption.length > 0;
  }

  const embroideryOption = props.productOptionVals.filter((option) =>
    option.name.toLowerCase().includes("embroidery")
  );
  const styleOption = props.productOptionVals.filter(
    (option) =>
      option.name.toLowerCase().includes("color") ||
      option.name.toLowerCase().includes("pattern") ||
      option.name.toLowerCase().includes("piping") ||
      option.name.toLowerCase().includes("stitching") ||
      option.name.toLowerCase().includes("style") ||
      option.name.toLowerCase().includes("rug size") ||
      option.name.toLowerCase().includes("robe size")
  );
  const hasStyleOption = styleOption.length > 0;

  // let visibleVariants = null
  const [visibleVariants, setVisibleVariants] = useState(null);
  const [hiddenVariants, setHiddenVariants] = useState(null);
  const [activeVariant, setActiveVariant] = useState(null);
  const [extraVariantData, setExtraVariantData] = useState(null);
  const [activeSize, setActiveSize] = useState(
    hasSizeOption ? sizeOption[0].values[0] : null
  );
  const [showDropdown, setShowDropdown] = useState(false);

  const [giftMessage, setGiftMessage] = useState("");

  useEffect(() => {
    if (initialRender.current) {
      initialRender.current = false;
    } else {   
      // check if has embroidery url params
      if (params.has("embvariant")) props.openEmbModal();
      if (activeVariant !== null && !isGiftCard) {
        // reselects the current color when changing sizes
        const currentColorVariant = visibleVariants.filter(
          (variant) =>
            variant[`option${styleOption[0].position}`] ===
            activeVariant[`option${styleOption[0].position}`]
        );
        if(currentColorVariant?.length>0){
        activateVariant(currentColorVariant[0]);
        }
        else{
          activateVariant(visibleVariants[0]);
        }
          if (hasSizeOption && activeSize==null) setActiveSize(sizeOption[0].values[0]);
      } else {
        let variantToActivate = visibleVariants[0];

        // if there are url params set active variant / and visible variants - pVID abbreviation stands for PRODUCT VARIANT ID
        const pVID = params.get("variant");
        if (pVID !== null) {
          const paramVariant = props.productObject.variants.filter(
            (variant) => variant.id === parseInt(pVID, 10)
          );
          // const paramVariant = visibleVariants.filter((variant) => variant.id === parseInt(pVID, 10))
          variantToActivate = paramVariant[0];

          // if variant has size options, set size to the param variant size
          if(sizeOption.length>0){ 
          const sizeOptionToActivate =
            variantToActivate[`option${sizeOption[0]?.position}`];
          if (hasSizeOption) setActiveSize(sizeOptionToActivate);
          }
        }
        if (variantToActivate) {
          activateVariant(variantToActivate);
        }
      }
    }
  }, [visibleVariants,activeSize]);

  useEffect(() => {
    filterCurrentVariants();
  }, [activeSize,props.productObject]);

  useEffect(() => {
    setUrl();
  }, [activeVariant]);

  useEffect(() => {
    props.productPage.activeQty = props.activeQty;
    props.setCurrentCount(props.activeQty);
  }, [props.activeQty]);
  const stylePos = hasStyleOption ? `option${styleOption[0].position}` : null;
  
  return (
    <div className="product__variants">
      {hasStyleOption && (
        <div className="product__variants__row product__variants__row--full">
          <div className="product__variants__row-block">
            <p className="product__variants__label">
              <span className="product__variants__option type type--medium">
                {/* {styleOption[0]?.name}: */}
                Style :
              </span>
              &nbsp;
              <span className="product__variants__selected-option type type--medium">
                {activeVariant !== null && activeVariant[stylePos]}
                {activeVariant !== null && (
                  <>
                    {activeVariant.available &&
                      extraVariantData?.inventory_quantity <= 0 && (
                        <span className="sold-out">
                          {" "}
                          •{" "}
                          {extraVariantData.metafields.variant_state_message !==
                          null
                            ? extraVariantData.metafields.variant_state_message
                            : "Backordered"}
                        </span>
                      )}
                    {!activeVariant.available && (
                      <span className="sold-out"> • Sold Out</span>
                    )}
                  </>
                )}
              </span>
            </p>
          </div>

          <div className="product__variants__row-block">
            <div className="product__variants__options-wrap">
              {visibleVariants !== null &&
                visibleVariants.map((variant, index) => (
                  <div
                    className={
                      "product__variants__item" +
                      `${variant.available ? "" : " sold-out"}`
                    }
                    key={variant.id}
                  >
                    <div
                      tabIndex="0"
                      title={
                        hasSizeOption
                          ? `${variant[`option${sizeOption[0].position}`]} / ${
                              variant[stylePos]
                            }`
                          : `${variant[stylePos]}`
                      }
                      variantid={variant.id}
                      className={`product__variants__item-inner ${
                        activeVariant?.id === variant.id ? "current" : ""
                      }`}
                      onKeyPress={(event) => keyPressVariant(event, variant)}
                      onClick={() => activateVariant(variant)}
                    >
                      {props.productData?.find((obj) => obj.id === variant.id)
                        .swatch && (
                        <img
                          alt={
                            `${
                              props.productData?.find(
                                (obj) => obj.id === variant.id
                              ).title
                            }` + " color swatch"
                          }
                          src={
                            props.productData?.find(
                              (obj) => obj.id === variant.id
                            ).swatch
                          }
                        ></img>
                      )}
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
      )}

      {/* SIZE VARIANT SELECTOR */}

      {hasSizeOption && !isGiftCard && !isBundle && (
        <div className="product__variants__row product__variants__row--border-top">
          {/* <div className="product__variants__row-block">
            <p className="product__variants__label type type--medium">
              <span className="product__variants__option type type--medium">
                {sizeOption[0]?.name}:
              </span>
              &nbsp;
              <span className="product__variants__selected-option type type--medium">
                {activeSize}
              </span>
            </p>
          </div> */}
          <div className="product__size-guide-wrap">
            <span>{sizeOption[0]?.name}:</span>
            <span>{activeSize}</span>
            {props?.sizeGuideType != null && (
              <button class="product__size-guide-trigger size-guide__toggle btn btn--text">
                Size Guide
              </button>
            )}
          </div>
          <div className="product__variants__row-block">
            <div className="product__variants__options-wrap">
              {sizeOption[0].values.map((size) => (
                <div
                  className="product__variants__item product__variants__item--right"
                  key={size}
                >
                  <div
                    tabIndex="0"
                    className={`product__variants__item-inner ${
                      size === activeSize ? "current" : ""
                    }`}
                    onKeyPress={(event) => keyPressSize(event, size)}
                    onClick={() => setSize(size)}
                  >
                    {size}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* BUNDLE VARIANT SELECTOR */}

      {/* {isBundle && !isGiftCard && (
        <div className="product__variants__row product__variants__row--border-top">
          <div className="product__size-guide-wrap">
            <span>{sizeOption[0]?.name}:</span>
            <span>{activeSize}</span>
            {sizeGuideType !=null && (
              <button class="product__size-guide-trigger size-guide__toggle btn btn--text">
                Size Guide
              </button>
            )}
          </div>
          <div className="product__variants__row-block">
            <div className="product__variants__options-wrap">
              {sizeOption[0].values.map((size) => (
                <div
                  className="product__variants__item product__variants__item--right"
                  key={size}
                >
                  <div
                    tabIndex="0"
                    className={`product__variants__item-inner product__variants__item-inner-size ${
                      size === activeSize ? "current" : ""
                    }`}
                    onKeyPress={(event) => keyPressSize(event, size)}
                    onClick={() => setSize(size)}
                  >
                    {size}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )} */}

      {/* GIFT CARD VARIANT SELECTOR */}

      {hasSizeOption && isGiftCard && (
        <>
          <div className="product__variants__row">
            <div className="product__variants__row-block product__variants__row-block--inline">
              <p className="product__variants__label">
                <span className="product__variants__option type type--medium">
                  {props.productOptionVals[0]?.name}
                </span>
                {/* <span className="product__variants__selected-option type type--medium">
                  { activeVariant !== null && activeVariant[`option1`]}
                </span> */}
              </p>
            </div>

            <div className="product__variants__row-block">
              <div className="product__variants__options-wrap product__variants__options-wrap--right">
                {visibleVariants !== null &&
                  visibleVariants.map((variant) => (
                    <div
                      className="product__variants__item product__variants__item--right"
                      key={variant.id}
                    >
                      <button
                        className={`product__variants__item-inner product__variants__item-inner--squared ${
                          activeVariant?.id === variant.id ? "current" : ""
                        }`}
                        onClick={() => activateVariant(variant)}
                      >
                        {variant.title}
                      </button>
                    </div>
                  ))}
              </div>
            </div>
          </div>

          {isDigitalGiftCard && (
            <>
              <div className="product__details">
                <p className="x-small">The Particulars</p>
              </div>

              <form className="product__form">
                <div className="product__form__row">
                  <div className="input-wrap half">
                    <label className="type type--small" htmlFor="recipientName">
                      Recipient’s name
                    </label>
                    <input
                      maxLength="100"
                      onChange={(e) =>
                        props.setExtraProperties({
                          ...props.extraProperties,
                          "Recipient’s name": e.target.value,
                        })
                      }
                      className="type type--medium"
                      type="text"
                      id="recipientName"
                      name="recipientName"
                    />
                  </div>

                  <div className="input-wrap half">
                    <label className="type type--small" htmlFor="senderName">
                      Sender’s name
                    </label>
                    <input
                      maxLength="100"
                      onChange={(e) =>
                        props.setExtraProperties({
                          ...props.extraProperties,
                          "Sender’s name": e.target.value,
                        })
                      }
                      className="type type--medium"
                      type="text"
                      id="senderName"
                      name="senderName"
                    />
                  </div>
                </div>

                <div className="product__form__row">
                  <div className="input-wrap">
                    <label
                      className="type type--small"
                      htmlFor="recipientEmail"
                    >
                      Sender’s email
                    </label>
                    <input
                      maxLength="100"
                      onChange={(e) =>
                        props.setExtraProperties({
                          ...props.extraProperties,
                          "Sender’s email": e.target.value,
                        })
                      }
                      className="type type--medium"
                      type="text"
                      id="senderEmail"
                      name="senderEmail"
                    />
                  </div>
                </div>

                <div className="product__form__row">
                  <div className="input-wrap">
                    <label className="type type--small" htmlFor="message">
                      Your message
                    </label>
                    <textarea
                      onChange={(e) => {
                        setGiftMessage(e.target.value);
                        props.setExtraProperties({
                          ...props.extraProperties,
                          "Your message": e.target.value,
                        });
                      }}
                      className="input-wrap__message type type--medium"
                      id="message"
                      name="message"
                      rows="2"
                      maxLength="200"
                    ></textarea>

                    <div className="input-wrap__count type type--small">
                      <span className="input-wrap__current-count">
                        {giftMessage.length}
                      </span>
                      /200
                    </div>
                  </div>
                </div>
              </form>
            </>
          )}
        </>
      )}

      {/* {!isGiftWrap &&
        <div className="product__quantity">
          <p className="type type--medium">Qty</p>
          <div className="product__count">
            <button onClick={() => setActiveQty(activeQty <= 1 ? 1 : activeQty - 1)} className="product__count__button product__count__button--minus" aria-label="Product quantity decrease">
              <svg viewBox="0 0 15 2" fill="none" xmlns="http://www.w3.org/2000/svg">
                <line x1="0.5" y1="1.03623" x2="14.5" y2="1.03623" stroke="#14334C" strokeWidth="1.2"/>
              </svg>
            </button>

            <span className="product__count__number type">{ activeQty }</span>

            <button onClick={() => setActiveQty(activeQty + 1)} className="product__count__button product__count__button--plus" aria-label="Product quantity increase">
              <svg viewBox="0 0 15 14" fill="none">
                <line x1="7.46377" y1="2.62269e-08" x2="7.46377" y2="14" stroke="#14334C" strokeWidth="1.2"/>
                <line x1="0.5" y1="7.03623" x2="14.5" y2="7.03623" stroke="#14334C" strokeWidth="1.2"/>
              </svg>
            </button>
          </div>
        </div>
      } */}
    </div>
  );
};

export default Variants;
